export default __webpack_public_path__ + "static/V-YLI_Ylivalotus2-c504edd380cdd254d10cc01341d23da1.jpg";